// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableRow: {
      '& thead': {
        background: `linear-gradient(to right, ${theme.palette.colors.blue}, ${theme.palette.colors.green})`,
      },
      '& thead th': {
        color: '#fff',
      },
      '& thead tr > *': {
        padding: theme.spacing(1, 2),
      },
      '& tbody tr > *': {
        padding: theme.spacing(1, 2),
      },
      '& tbody tr:nth-of-type(even)': {
        background: '#eeea',
      },
    },
    evenRow: {
      background: '#fff ',
      '&  td:first-child': {
        borderRight: '2px solid #E1E8ED',
      },
      '& td:first-child': {
        borderRight: '2px solid #E1E8ED',
      },
    },
    oddRow: {
      background: '#F5F8FA ',
      '&  td:first-child': {
        borderRight: '2px solid #E1E8ED',
      },
      '& td:first-child': {
        borderRight: '2px solid #E1E8ED',
      },
    },
    collapseEvenRow: {
      background: '#fff ',
    },
    collapseOddRow: {
      background: '#F5F8FA ',
    },
    driverName: { minWidth: 240 },
  }),
);

export default useStyles;
